import { createContext, useContext } from 'react';

// The assistant's conversation and whether its panel is open, provided by the
// help centre's routes so both outlive a page change: a reader who opens an
// article the assistant cited finds the conversation where they left it.
const HelpAssistantContext = createContext(null);

export const useHelpAssistantContext = () => useContext(HelpAssistantContext);

export default HelpAssistantContext;
